<template>
  <div class="paddedPage">
    <MultiColumnTable :tableKey="tableKey" :key="tableKey"></MultiColumnTable>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import MultiColumnTable from "./MultiColumnTable.vue";

let props = defineProps([
  "tableKey"
]);

let route = useRoute();
let tableKey = computed(() => {
  if (props.tableKey)
    return props.tableKey;
  else if (route.path == "/")
    return "binStatus";
  else
    return route.path.slice(1);
});
</script>